import {
  Button,
  ButtonGroup,
  Container,
  Divider,
  IconButton,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Image } from "@chakra-ui/image";
import * as React from "react";
import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";

import logo from "../../logo/logo.png";

export default function Footer() {
  return (
    <Container
      as="footer"
      role="contentinfo"
      maxWidth="100%"
      backgroundColor="white"
    >
      <Stack
        spacing="4"
        direction={{ base: "column", md: "column", xl: "row" }}
        justify="space-between"
        py={{ base: "12", md: "16" }}
      >
        <Stack spacing={{ base: "6", md: "8" }} align="start" flexShrink="0">
          <Image
            src={logo}
            alt="qatar university logo"
            width={{ base: "45%", md: "30%", xl: "50%" }}
          />
          <Text color="muted">Qatar University Machine Learning Group</Text>
        </Stack>
        <Stack
          direction={{
            base: "column-reverse",
            md: "column",
            lg: "column",
            xl: "row",
          }}
          spacing={{ base: "12", md: "20", xl: "20" }}
        >
          <Stack direction="row" spacing="8" flexWrap="wrap" gap="25px">
            <Stack minW="36" flex="1">
              <Text fontSize="20px" fontWeight="semibold" color="subtle">
                Team Members
              </Text>
              <Stack spacing="3" shouldWrapChildren>
                <a href="/team-members/current-team-members">
                  <Button
                    variant="link"
                    _focus={{
                      boxShadow: "none",
                    }}
                    fontSize="18px"
                  >
                    Current Team Members
                  </Button>
                </a>

                <a href="/team-members/lab-alumni">
                  <Button
                    variant="link"
                    _focus={{
                      boxShadow: "none",
                    }}
                    fontSize="18px"
                  >
                    Lab Alumni
                  </Button>
                </a>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Divider />
      <Stack
        pt="8"
        pb="12"
        justify="space-between"
        direction={{ base: "column-reverse", md: "row" }}
        align="center"
      >
        <Text fontSize="sm" color="subtle">
          &copy; {new Date().getFullYear()} Qatar University Machine Learning
          Lab. All rights reserved.
        </Text>
        <ButtonGroup variant="ghost" gap="20px">
          <IconButton
            as="a"
            href="#"
            aria-label="LinkedIn"
            icon={<FaLinkedin fontSize="40px" color="#0077b5" />}
          />
          <IconButton
            as="a"
            href="#"
            aria-label="GitHub"
            icon={<FaGithub fontSize="40px" />}
          />
          <IconButton
            as="a"
            href="#"
            aria-label="Twitter"
            icon={<FaTwitter fontSize="40px" color="#1DA1F2" />}
          />
        </ButtonGroup>
      </Stack>
    </Container>
  );
}
